import { render, staticRenderFns } from "./MemberRegisterIframe.vue?vue&type=template&id=cf4d4126&"
import script from "./MemberRegisterIframe.vue?vue&type=script&lang=ts&"
export * from "./MemberRegisterIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports